module.exports = __webpack_public_path__ + "static/media/logo.36915178.png";